<template>
    <div class="filterable-listbox bg-white">
    <div class="block">
      <div class="common-modal-header list-modal-header d-flex flex-column align-items-start">
        <div class="default-column-name">
          <span class="default-column-title"> {{columnName}} </span>
        </div>
      <div v-if="!disableChangeColumnName" class="editLabel d-flex flex-row align-items-center" @click="onEditLabelHeader">
        <div class="optionEditLabel">
          <i class="material-icons material-icons-outlined icon_edit">
            edit
          </i>
          <span class="text">表示名を変更</span>
        </div>
      </div>
      <div v-if="!disableChangeColumnName" class="line"></div>
        <div
          v-if="!hideSortOrder"
          :class="[{ active: this.sortBy == 1 }, 'sortByAsc d-flex flex-row align-items-center']"
          @click="onSortByAsc"
        >
          <div class="optionSort">
            <i class="material-icons material-icons-outlined arrow_upward">
              arrow_upward
            </i>
            <span class="text">A to Zで並べ替え</span>
          </div>
        </div>
        <div
          v-if="!hideSortOrder"
          :class="[{ active: this.sortBy == 2 }, 'sortByDesc d-flex flex-row align-items-center']"
          @click="onSortByDesc"
        >
          <div class="optionSort">
            <i class="material-icons material-icons-outlined arrow_downward">
              arrow_downward
            </i>
            <span class="text">Z to Aで並べ替え</span>
          </div>
        </div>
      </div>
      <div v-if="!hideSortOrder" class="line"></div>
      <!-- block initialize the list of tags -->
      <div
        class="d-flex block_tags"
      >
        <span
          v-for="(item, index) in selectedItems"
          :key="index"
          class="tag"
        >
          <span class="text width-default-tag">{{item.name}}</span>
          <i
            class="material-icons material-icons-outlined"
            @click.prevent.stop="removeItem(selectedItems[index])"
          >
            close
          </i>
        </span>
      </div>
      <div class="list_filter_input">
        <b-form-input
          autocomplete="off"
          type="text"
          ref="inputDialogListFilter"
          @keyup="filterItem($event)"
          placeholder="検索 または 選択してください"
        />
      </div>
      <div class="line"></div>
      <!-- block initialize the list to be selected -->
      <div
        class="block_listBox"
        >
      <ul
        class="listBox"
        v-for="(key, index) in options"
        :key="index"
      >
        <li @click.prevent.stop="addItem(options[index])">{{key.name}}</li>
      </ul>
      </div>
      <div class="list-modal-footer d-flex flex-row align-items-center justify-content-around">
        <b-button variant="info" class="btnCheckAll btn-info" @click.prevent="togleAll">
          {{selectedItems.length ? 'すべて外す' : 'すべてチェック'}}
        </b-button>
        <b-button variant="info" class="btnOk btn-info" @click.prevent="onSubmit">
          OK
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
const SORT_ASC_MODE = 1
const SORT_DESC_MODE = 2
export default {
  data() {
    return {
      isItemNoLocal: this.isItemNo,
      sortBy: null,
      selectedItems: [],
      options: [],
      originalOptions: [],
      columnName: this.defaultItemName
    }
  },
  props: ['isItemNo', 'pListSelected', 'pOption', 'defaultItemName', 'disableChangeColumnName', 'hideSortOrder'],
  watch: {
    isItemNo: function (newValue, oldValue) {
      this.isItemNoLocal = newValue
    },
    pListSelected: {
      handler: function (newValue, oldValue) {
        if (
          newValue &&
          Array.isArray(newValue[this.isItemNoLocal]) &&
          newValue[this.isItemNoLocal].length
        ) {
          this.selectedItems = newValue[this.isItemNoLocal]
        }
      },
      deep: true
    },
    pOption: function (newValue, oldValue) {
      if (newValue) {
        let item = []
        if (!this.options.length) {
          this.selectedItems = [...newValue]
        } else {
          if (newValue.length > oldValue.length) {
            item = this.filterValueIsDifferent(newValue, oldValue)
            this.options = this.options.concat(item)
          } else if (newValue.length < oldValue.length) {
            item = this.filterValueIsDifferent(oldValue, newValue)
            this.options = this.options.filter(option => !item.includes(option))
          } else {
            this.options = this.filterValueIsDifferent(newValue, this.selectedItems)
          }
          this.originalOptions = this.options
          this.selectedItems = this.filterValueIsDifferent(newValue, this.options)
        }
      }
    }
  },
  methods: {
    // remove item from selected list
    removeItem(item) {
      this.options.unshift(item)
      this.selectedItems = this.removeElementArray(item, this.selectedItems)
      this.originalOptions = this.options
    },
    // add item to selected list
    addItem(item) {
      this.$refs['inputDialogListFilter'].localValue = ''
      this.selectedItems.push(item)
      this.removeElementArray(item, this.originalOptions)
      this.options = [...this.originalOptions]
    },
    filterItem(e) {
      this.options = [...this.originalOptions.filter(s => s.name.includes(e.target.value))]
    },
    /**
     * 'code' 属性に基づいて、2つの配列の異なる要素をフィルタリングします。
     * @param {array} valueArray valueArrayという配列 。
     * @param {array} differentValueArray valueArrayとは異なる要素を含む配列。
     * @return {array} valueArrayという配列の中で、differentValueArrayという配列のどの要素とも異なる'code'属性を持つ要素を含む配列を返してください。
     */
    filterValueIsDifferent(valueArray, differentValueArray) {
      return valueArray.filter(itemValue => !differentValueArray.some(differentItemValue => itemValue.code === differentItemValue.code))
    },
    togleAll() {
      if (this.selectedItems.length === 0) {
        this.selectedItems = [...this.pOption]
        this.options = []
        this.originalOptions = []
      } else {
        this.originalOptions = [...this.pOption]
        this.selectedItems = []
        this.options = [...this.pOption]
      }
    },
    resetValueComponent() {
      this.initData()
    },
    initValueComponent(sort, isItemNo) {
      this.initData()
      if (sort.propetyName === isItemNo) {
        this.sortBy = sort.order
      } else {
        this.sortBy = null
      }
    },
    onSubmit() {
      if (
        this.selectedItems.length === this.pOption.length ||
        this.selectedItems.length === 0
      ) {
        this.$emit('on-submit', {itemNo: this.isItemNoLocal, selected: []})
      } else {
        this.$emit('on-submit', {itemNo: this.isItemNoLocal, selected: this.selectedItems.map(s => s.code)})
      }
    },
    onSortByDesc() {
      this.sortBy = this.toggleSort(SORT_DESC_MODE)
      this.$emit('on-sort', {order: this.sortBy, propetyName: this.getPropertyNameBySort(this.sortBy)})
    },
    onSortByAsc() {
      this.sortBy = this.toggleSort(SORT_ASC_MODE)
      this.$emit('on-sort', {order: this.sortBy, propetyName: this.getPropertyNameBySort(this.sortBy)})
    },
    removeElementArray(item, array) {
      let index = array.indexOf(item)
      if (index !== -1) {
        array.splice(index, 1)
      }
      return array
    },
    initData() {
      if (this.pListSelected.length === 0) {
        this.selectedItems = [...this.pOption]
        this.options = []
        this.originalOptions = []
      } else {
        this.selectedItems = []
        this.options = []
        for (let key in this.pOption) {
          if (this.pListSelected.indexOf(this.pOption[key].code) !== -1) {
            this.addElementArray(this.pOption[key], this.selectedItems)
          } else {
            this.addElementArray(this.pOption[key], this.options)
            this.originalOptions = this.options
          }
        }
      }
    },
    addElementArray(item, currentArray) {
      const indexOf = currentArray.indexOf(item)
      if (indexOf === -1) {
        currentArray.push(item)
      }
    },
    onEditLabelHeader() {
      this.$emit('allow-edit-label')
    },
    toggleSort(value) {
      if (this.sortBy !== value) {
        return value
      }
      return null
    },
    getPropertyNameBySort(sortBy) {
      return sortBy ? this.isItemNoLocal : null
    }
  }
}
</script>

<style lang="scss" scoped>
.filterable-listbox {
  min-height: 100px;
  height: fit-content;
  // 320px is the total height of page header (68px) + alert message (70px) + sub menu (91px) +
  // action buttons (delete all / add / search / show / hide / import / export / delete / revert / sort button) (48px) + table header (43px)
  max-height: calc(100vh - 320px);
  overflow-y: auto;
  cursor: default;

}
@mixin setListBoxHeight() {
  min-height: 0px;
  // 320px はリスト内の 3 つの項目の合計の高さです
  max-height: 130px;
}
.block {
  padding: 0 0 4px 8px;
  width: 280px;
  .list_filter_input {
    input {
      @include textOverflowEllipsis(false, 1)
    }
  }
}
.line {
  width: 272px;
  height: 1px;
  left: 8px;
  top: 92px;
  margin: 8px 0;
  background: $line_gray;
}
.list-modal-footer {
  padding: 8px 0;
  padding-right: 8px;
  width: 272px;
  height: 58px;
  .btnCheckAll {
    width: auto;
    height: 42px;
    border-radius: 4px;
    padding: 0 5px;
  }
  .btnRemoveAll {
    font-style: normal;
    font-weight: normal;
    @include responsive-fs(12);
    line-height: 160%;
    color: $sucess;
    padding: 0;
    &:hover {
      text-decoration: none;
    }
  }
  .btnOk{
    border-radius: 4px;
    height: 42px;
    display: flex;
    align-items: center;
  }
}
.list-modal-header {
  .default-column-name {
    right: 8px;
    bottom: unset;
  }
}
.arrow_downward, .arrow_upward {
  @include responsive-fs(15);
}
.icon_edit {
  @include responsive-fs(14);
}
.block_tags {
  margin: 10px 0 0;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  @include setListBoxHeight();
  .tag {
    background: rgba(78, 102, 166, 0.08);
    border-radius: 4px;
    color: #252422;
    display: flex;
    align-items: center;
    justify-content: space-between;
    @include responsive-fs(12, true);
    width: auto;
    height: auto;
    margin-right: 10px;
    margin-top: 3px;
    margin-bottom: 3px;
    font-weight: normal;
    font-family: $default-font-family;
    i {
      @include responsive-fs(16, true);
      padding: 8px 8px 8px 8px;
    }
    .text {
      @include responsive-fs(16, true);
      padding: 4px 0 4px 8px;
      word-wrap: break-word !important;
      white-space: normal !important;
    }
  }
}
.inputText {
  margin: 5px 0;
}
.listBox {
  list-style: none;
  width: 100%;
  padding: 0;
  li {
    height: auto;
    min-height: 40px;
    padding: 8px 8px 8px 4px;
    display: flex;
    flex-direction: row;
    align-items: center;
    font-family: $default-font-family;
    font-weight: normal;
    @include responsive-fs(16);
    word-wrap: break-word !important;
    white-space: normal !important;
  }
  li:hover {
    background: rgba(78, 102, 166, 0.08);
    border-radius: 8px 0px 0px 8px;
  }
}
.block_listBox {
  overflow: auto;
  @include setListBoxHeight();
}
.width-default-tag {
  min-width: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/custom-components/FilterableListbox.vue